import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Call4uAudio } from 'src/app/models/Call4uAudio';
import { environment } from 'src/environments/environment';

export interface DtmfAction {
  dtmf_key: string;
  action_type: string;
  action_params?: any;
}

export interface PaginatedResponse<T> {
  current_page: number;
  data: T[];
  last_page: number;
  per_page: number;
  total: number;
}

@Injectable({ providedIn: 'root' })
export class Call4uAudioService {

  constructor(private http: HttpClient) { }

  list(page: number = 1, perPage: number = 100): Observable<PaginatedResponse<Call4uAudio>> {
    return this.http.get<PaginatedResponse<Call4uAudio>>(
      `${environment.apiUrl}/call4u/audios`,
      { params: { page: page.toString(), per_page: perPage.toString() } }
    );
  }

  findById(id: string): Observable<Call4uAudio> {
    return this.http.get<Call4uAudio>(`${environment.apiUrl}/call4u/audios/${id}`);
  }

  upload(file: File, title: string, ttsText: string, actions?: DtmfAction[]): Observable<HttpEvent<Call4uAudio>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('type', 'upload');
    if (ttsText) {
      formData.append('tts_text', ttsText);
    }
    if (actions && actions.length > 0) {
      formData.append('actions', JSON.stringify(actions));
    }
    const req = new HttpRequest('POST', `${environment.apiUrl}/call4u/audios`, formData, {
      reportProgress: true
    });
    return this.http.request<Call4uAudio>(req);
  }

  generateTTS(title: string, ttsText: string, actions?: DtmfAction[], voiceId?: string): Observable<Call4uAudio> {
    const body: any = { title, tts_text: ttsText, type: 'tts' };
    if (voiceId) { body.tts_voice_id = voiceId; }
    if (actions && actions.length > 0) { body.actions = actions; }
    return this.http.post<Call4uAudio>(`${environment.apiUrl}/call4u/audios`, body);
  }

  previewTTS(ttsText: string, voiceId?: string): Observable<Blob> {
    const body: any = { tts_text: ttsText };
    if (voiceId) { body.tts_voice_id = voiceId; }
    return this.http.post(`${environment.apiUrl}/call4u/audios/preview-tts`, body, {
      responseType: 'blob'
    });
  }

  update(id: string, data: { title?: string; tts_text?: string; actions?: DtmfAction[] }): Observable<Call4uAudio> {
    return this.http.put<Call4uAudio>(`${environment.apiUrl}/call4u/audios/${id}`, data);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/call4u/audios/${id}`);
  }
}
